import { confetti } from 'tsparticles-confetti';

if ($('.confetti_canvas')[0]) {
    var counterID = 0;

    $('.block--cta--large').each(function () {
        var canvas_wrap = $(this);
        $(canvas_wrap)
            .find('.confetti_canvas')
            .attr('id', 'confetti-' + counterID);

        (async () => {
            const canvas = document.getElementById('confetti-' + counterID);
            canvas.confetti =
                canvas.confetti ||
                (await confetti.create(canvas, { resize: true }));


                const defaults = {
                  spread: 360,
                  ticks: 100,
                  gravity: 0,
                  decay: 0.94,
                  startVelocity: 30,
                  shapes: ["circle", "square", "heart", "star"],
                  colors: ["83F39B", "C9F6F9", "C362EB", "FBDCDC", "19A6E8", "FBD6E8"],
                };
                
                function shoot() {
                  canvas.confetti({
                    ...defaults,
                    particleCount: 40,
                    scalar: 0.75,
                  });
                  canvas.confetti({
                    ...defaults,
                    particleCount: 25,
                    scalar: 0.5,
                  });
                  canvas.confetti({
                    ...defaults,
                    particleCount: 10,
                    scalar: 1.5,
                  });
                }

            $(canvas_wrap).find('button, .button').mouseenter(function () {
              setTimeout(shoot, 0);
              setTimeout(shoot, 100);
              setTimeout(shoot, 200);
            });
        })();

        counterID++;
    });
}



if ($('.page--stars')[0]) {

  const defaults = {
    spread: 360,
    ticks: 100,
    gravity: 0,
    decay: 0.94,
    startVelocity: 30,
    shapes: ["circle", "square", "heart", "star"],
    colors: ["83F39B", "C9F6F9", "C362EB", "FBDCDC", "19A6E8", "FBD6E8"],
  };
  
  function shoot() {
    confetti({
      ...defaults,
      particleCount: 40,
      scalar: 0.75,
    });
    confetti({
      ...defaults,
      particleCount: 25,
      scalar: 0.5,
    });
    confetti({
      ...defaults,
      particleCount: 10,
      scalar: 1.5,
    });
  }

  setTimeout(shoot, 0);
  setTimeout(shoot, 100);
  setTimeout(shoot, 200);

}
